// extracted by mini-css-extract-plugin
export default {"app_main_layout_content":"list_app_main_layout_content__qcX-M","list":"list_list__75Frd"};